import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';

@Component({
  selector: 'app-DocumentTitleList',
  templateUrl: './DocumentTitleList.component.html',
  styleUrls: ['./DocumentTitleList.component.scss']
})
export class DocumentTitleListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DocumentTitle_Service:DocumentTitleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_DocumentTitle:Array<General_Group_Interface>=[]
  Data_Seleted_Delete:General_Group_Interface=Empty_General_Group_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(27).subscribe(
      data=>{
        this.ReadData_DocumentTitle()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_DocumentTitle(){
    this.Procssing=true
    this.DocumentTitle_Service.GetRecord().subscribe(
      data=>{
        this.DataList_DocumentTitle=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Group_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.DocumentTitle_Service.DeleteDocumentTitle(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_DocumentTitle()
      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
